import { render, staticRenderFns } from "./ABtn.vue?vue&type=template&id=2e839316&scoped=true&"
import script from "./ABtn.vue?vue&type=script&lang=js&"
export * from "./ABtn.vue?vue&type=script&lang=js&"
import style0 from "./ABtn.vue?vue&type=style&index=0&id=2e839316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e839316",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
